module.exports = {"id":"202858","name":"Fabián Castillo","rating":"75","photo":"./data/images/photos/3/202858.png","club":{"name":"Trabzonspor","logo":"./data/images/clubs/Trabzonspor.png"},"positions":["MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianCastillo0.json
// module id = 1325
// module chunks = 0